import React from "react";
import Layout from "../layouts/index";
import UserProfile from "../screens/Account/UserProfile";

const UserProfilePage = () => {
  return (
    <Layout>
      <UserProfile />
    </Layout>
  );
};

export default UserProfilePage;
